import { ALLOWED_IMAGE_MIME_TYPES, ALLOWED_REFERENCE_IMAGE_MIME_TYPES, IMAGE_TOO_LARGE_MESSAGE, IMAGE_UPLOAD_MAX_BYTES } from "./constants";

export const IMAGE_DROPZONE_ACCEPT = Object.fromEntries(ALLOWED_IMAGE_MIME_TYPES.map((mimeType) => [mimeType, []])) as Record<string, string[]>;

export const REFERENCE_IMAGE_DROPZONE_ACCEPT = Object.fromEntries(ALLOWED_REFERENCE_IMAGE_MIME_TYPES.map((mimeType) => [mimeType, []])) as Record<string, string[]>;

const ALLOWED_TYPES_LABEL = ALLOWED_IMAGE_MIME_TYPES.map((mimeType) => mimeType.split("/")[1].toUpperCase()).join(", ");

const ALLOWED_REFERENCE_TYPES_LABEL = ALLOWED_REFERENCE_IMAGE_MIME_TYPES.map((mimeType) => mimeType.split("/")[1].toUpperCase()).join(", ");

export function handleImagesDropped(acceptedFiles: File[], onFilesAdded: (files: File[]) => void, onError: (message: string | null) => void) {
  const tooLarge = acceptedFiles.filter((file) => file.size > IMAGE_UPLOAD_MAX_BYTES);
  const valid = acceptedFiles.filter((file) => file.size <= IMAGE_UPLOAD_MAX_BYTES);
  // Always report a definitive outcome for this drop (an error, or an explicit clear) rather than
  // only setting an error and never clearing one — the caller's own error state may be stale from
  // a previous drop, and a size-only rejection shouldn't be silently overwritten by an unrelated
  // caller-side clear that doesn't know this drop had one.
  onError(tooLarge.length > 0 ? IMAGE_TOO_LARGE_MESSAGE : null);
  if (valid.length > 0) onFilesAdded(valid);
}

export function handleImagesDropRejected(onError: (message: string) => void) {
  onError(`Unsupported image type. Allowed types: ${ALLOWED_TYPES_LABEL}.`);
}

export function handleReferenceImageDropRejected(onError: (message: string) => void) {
  onError(`Unsupported image type. Allowed types: ${ALLOWED_REFERENCE_TYPES_LABEL}.`);
}
